<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>e-Ginga Ansião - Acordo de Utilização</title>
</head>
<body>
    <ng-container *transloco="let t">
    <div class="container">
        <div class="header">
            <a routerLink="/"><img src="./img/logo.png" alt="Company Logo" class="logo"></a>
            <h1>{{ t('agreement.title') }}</h1>
            <div class="language-selector">
            <button (click)="changelanguage('en')" class="btn-lang">ENG</button>
            <button (click)="changelanguage('pt')" class="btn-lang">PT</button>
            </div>
        </div>
        <div class="content">
            <p><strong>{{ t('agreement.title') }}</strong></p>
            <ol>
                <li>
                    <p><strong>{{ t('agreement.sections.1.title') }}</strong></p>
                    <p>{{ t('agreement.sections.1.content') }}</p>
                </li>
                <li>
                    <p><strong>{{ t('agreement.sections.2.title') }}</strong></p>
                    <p>{{ t('agreement.sections.2.content') }}</p>
                </li>
                <li>
                    <p><strong>{{ t('agreement.sections.3.title') }}</strong></p>
                    <p>{{ t('agreement.sections.3.content') }}</p>
                </li>
                <li>
                    <p><strong>{{ t('agreement.sections.4.title') }}</strong></p>
                    <p>{{ t('agreement.sections.4.content') }}</p>
                </li>
                <li>
                    <p><strong>{{ t('agreement.sections.5.title') }}</strong></p>
                    <p>{{ t('agreement.sections.5.content') }}</p>
                </li>
                <li>
                    <p><strong>{{ t('agreement.sections.6.title') }}</strong></p>
                    <p>{{ t('agreement.sections.6.content') }}</p>
                </li>
                <li>
                    <p><strong>{{ t('agreement.sections.7.title') }}</strong></p>
                    <p>{{ t('agreement.sections.7.content') }}</p>
                </li>
                <li>
                    <p><strong>{{ t('agreement.sections.8.title') }}</strong></p>
                    <p>{{ t('agreement.sections.8.content') }}</p>
                </li>
                <li>
                    <p><strong>{{ t('agreement.sections.9.title') }}</strong></p>
                    <p>{{ t('agreement.sections.9.content') }}</p>
                </li>
                <li>
                    <p><strong>{{ t('agreement.sections.10.title') }}</strong></p>
                    <p>{{ t('agreement.sections.10.content') }}</p>
                </li>
            </ol>
        </div>
    </div>
    <div class="footer">
        <span>&copy; 2026 <script>document.write(new Date().getFullYear())</script> <a href="https://www.wegoshare.com" target="_blank">Wegoshare</a>. {{ t('footer.rights') }}</span>
        <span>
            <div class="footer-links">
                <a routerLink="/">{{ t('footer.home') }}</a>&nbsp;&nbsp;&nbsp;
            <a routerLink="/Politica-de-Privacidade">{{ t('footer.privacy') }}</a>&nbsp;&nbsp;&nbsp;
            <a routerLink="/Acordo-de-Utilização">{{ t('footer.agreement') }}</a>
            </div>
        </span>
    </div>
</ng-container>
</body>
</html>